import Cookie from 'js-cookie';
import { store } from '../store/store';

export default async function navigationGuard(to, from, next) {
  if (to.matched[0].meta.subPage !== undefined) {
    store.state.subPage = to.matched[0].meta.subPage;
  }

  if (to.query && to.query.assessor_nav !== undefined) {
    Cookie.set('assessor_nav', to.query.assessor_nav, { expires: 365 });
  }

  const tokenNotExpired = new Date(localStorage.getItem('expireAt')) > new Date();

  // if (tokenNotExpired) {
  //   console.log(tokenNotExpired, store.state.users);
  //   store.state.users.user = {};
  //   return localStorage.clear();
  // }

  const isLoggedIn = localStorage.getItem('token') && tokenNotExpired;
  const role = localStorage.getItem('role');
  const adminRoles = store.state.adminRoles;

  const { isPublic, isPrivate } = to.meta || {};

  const loggedUserAccessPublicRoute = isLoggedIn && isPublic && !isPrivate;
  const notAuthorized = isLoggedIn && !adminRoles.includes(role);

  // prevent to access private rout while not logged in
  if (!isLoggedIn && to.path !== '/login' && !isPublic) {
    // await store.restored;
    store.state.users.user = {};
    return next({ path: '/login' });
  }

  // prevent to access public route while logged
  if (notAuthorized && to.path.includes('admin')) {
    await store.restored;
    return next({ path: '/' });
  }
  if (loggedUserAccessPublicRoute && to.path !== '/logout') {
    await store.restored;
    return next({ path: '/' });
  }

  if (isLoggedIn) {
    try {
      await store.dispatch('users/GET_USER_BY_ID');
    } catch (error) {
      console.error('Failed to perform action on route change:', error);
    }
  }
  if (!isLoggedIn && to.name !== 'login' && to.meta.requiresAuth) {
    next({ name: 'login' });
  } else if (isLoggedIn && to.name === 'login') {
    next({ path: '/' });
  } else {
    next();
  }

  await store.restored;
  next();
}
